/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-22",
    versionChannel: "nightly",
    buildDate: "2025-05-22T00:06:54.631Z",
    commitHash: "db8c55d7cfb1ac342116f42910987ae0ebe70119",
};
